import { Alert, Snackbar } from "@mui/material";

export default function CenteredAlert(params:
    {
        open: boolean,
        alertText: string,
        severity: "success" | "info" | "warning" | "error",
        borderColor?: string,
        onClose: () => void;
    }) {

    return (
        <Snackbar
            sx={{ height: "100%" }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={params.open}
            autoHideDuration={3000}
            onClose={params.onClose}

        >
            <Alert onClose={params.onClose} severity={params.severity} sx={{ width: "500px", border: `2px solid ${params.borderColor}` }}>
                {params.alertText}
            </Alert>
        </Snackbar>
    );
};

